<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system';
	import { capFirstChar } from 'src/helpers/utilities';
</script>

<Text class="mb-s"
	>{$format('text_blu_trv_pairing', {
		default: 'TRV Inclusion Info Content',
	})}</Text
>

<div class="mb-s d-flex justify-content-center align-items-center">
	<svg height="172" width="132" viewBox="0 0 172 132"
		><g id="trv-body" style="fill:none;stroke:#ffffff">
			<path
				style="stroke-width:0.5px"
				d="M34.4,55.9c-.2.2-.4.4-.6.5-.2,0-.5,0-.8,0-.1,0-.3-.1-.4-.2-.1,0-.2-.2-.3-.4-.2-.3-.4-.6-.4-1,0-.2,0-.4,0-.6,0-.2,0-.4,0-.6,0-.4.2-.7.4-1,.2-.2.4-.4.6-.5.2,0,.5,0,.7,0,.3,0,.5.3.7.6.2.3.4.6.4,1,.2.8,0,1.6-.4,2.1ZM53.7,130.3c12-3.8,19.8-16.7,20.4-33.8.6-17.1-6-35.7-17.3-48.6-11.3-12.9-24.9-18.1-36.5-13.5M29.3,126c0-.3,0-.5,0-.8,0-1,.4-1.2,1.6-.6s.3,0,.5.2.2,0,.2.1M36.1,128c19.4,6.7,35-8.3,35.2-33.5.2-25.2-15.3-51.1-34.6-57.8C17.4,30,1.5,45,1.3,70.1c-.2,22.2,11.8,44.8,27.8,54.5M136.4,11.7c10.6,9.3,18.3,23.6,21.1,39.8s1.4,14.2.3,20.6M169.9,57.9v-.3c0,0-11.4,4-11.4,4M153.7,14.7h.2M156.7,16.8h.2M140.9,16.3l9.6-3.4M142.9,18.5l10.8-3.8M148.7,27.2l13.4-4.7M170.4,41.8l-13.9,4.9M158.3,58.3l12.3-4.4M146.7,23.9l12.7-4.5M170.9,45.9l-13.5,4.8M158,54.6l13-4.6M144.7,21l11.9-4.2M157.8,72.7c.3-2.1.4-4.3.4-6.5h0c0-8.2-1.4-16.9-4.3-25.1-2.3-6.7-5.6-13.1-9.5-18.7-2.8-4-5.9-7.6-9.3-10.6-4.1-3.8-8.6-6.7-13.1-8.6"
			/><path
				style="stroke-width:1px"
				d="M157.8,72.7c-1.9,15.9-10.2,28-21.8,31.7l-82.3,26c-5.3,1.7-11.3,1.1-17.2-0.9l-0.2-0.1 c-0.1-0.8-0.1-2.2-0.9-2.5c-0.8-0.3-2.7-1.2-3.9-1.8l-0.2-0.1l-2,1.1c-5.1-3.1-9.9-7.5-14.1-13C2.5,96.6-2.6,73.4,2.4,55.6 c2.8-9.8,8.2-16.7,15.2-20l0.6-0.3l81.6-33c4.4-1.7,9.2-2.2,14-1.5c2.7,0.4,5.5,1.2,8.2,2.4l0.2-0.1c4.9,1.7,9.7,4.6,14.2,8.6 l1-0.4c3.6-1.3,7.5-1.1,11.5,0.4c0.5,0.3,1,0.7,1.5,1l0.1,0.1l0.5-0.2c0.4,0.2,0.7,0.4,1.1,0.6c0.5,0.4,0.9,0.8,1.4,1.1l0.1,0.3 l0.2-0.1c0.1,0,0.2,0,0.3,0c0.3,0.2,0.7,0.5,1,0.8c0.4,0.4,0.9,0.8,1.3,1.2l0.1,0.3l0.2,0c0.1,0.1,0.3,0.1,0.4,0.2 c0.3,0.3,0.7,0.6,1,0.9c0.4,0.4,0.8,0.8,1.1,1.3l0.1,0.3l0.2,0c0.1,0.1,0.3,0.2,0.4,0.4c0.3,0.3,0.6,0.7,0.9,1.1 c0.3,0.4,0.7,0.8,1,1.3l0.1,0.3l0.2,0.1c0.1,0.1,0.2,0.3,0.3,0.4l0.2,0.3c3.8,5.3,6.5,11.7,7.7,18.3l-0.1,0.2l0.2,0.2 c0.2,1.2,0.4,2.5,0.4,3.7l-0.1,0.2l0.2,0.3l0,0.4c0,0.4,0,0.8,0.1,1.2c0,0.5,0,1,0,1.4c0,0.2,0,0.4,0,0.6L171,50l0.1,0.3 c0,0.5,0,1.1,0,1.7c0,0.5-0.1,0.9-0.1,1.4c0,0.1-0.1,0.3-0.2,0.4l-0.2,0.1l0.1,0.3c-0.1,0.6-0.1,1.1-0.2,1.7 c-0.1,0.4-0.2,0.9-0.3,1.3c-0.1,0.1-0.2,0.2-0.2,0.2l-0.2,0.1l0.1,0.3c-0.1,0.6-0.2,1.2-0.3,1.8c-1.7,5.1-4.7,9-8.6,11.2l-1.6,0.6 l-0.2,0.3c-0.1,0-0.2,0.1-0.3,0.1l-1,0.4L157.8,72.7z"
			/></g
		>
		<g id="arrows" style="fill:#ffffff">
			<path
				d="M96.6,53.7c-5.5-12.4-14-23-23.8-29.1l-7.7,2.8,7.4-9.5c7.5-1.2,15.6-1.7,24-1.6l-7.8,2.8c9.9,6.1,18.3,16.7,23.9,29.1l-16,5.7Z"
			/>
			<path
				d="M112.6,48c-5.5-12.4-14-23-23.9-29.1l-15.9,5.7c9.9,6.1,18.3,16.7,23.8,29.1l-7.8,2.8,18.1.4c5-3,7.6-6.1,13.3-11.6l-7.7,2.7Z"
			/>
			<path
				d="M116.9,60.4c1.7,6.4,2.5,12.9,2.5,19.5,0,6.8-1.1,13-3,18.4l-16,5.7c1.9-5.4,3-11.6,3-18.4s-.8-13.1-2.5-19.5l-7.7,2.8,13.9-11.9c6,0,11.4.3,17.6.8l-7.8,2.8Z"
			/>
			<path
				d="M116.9,60.4c1.7,6.4,2.5,12.9,2.5,19.5,0,6.8-1.1,13-3,18.4l7.6-2.7c-6,5.3-12.5,10-19.7,13.9l-11.8-2.8,7.8-2.8c1.9-5.4,3-11.6,3-18.4s-.8-13.1-2.5-19.5l16-5.6Z"
			/>
		</g>
		<path
			style="fill:white"
			d="M16.8,67.7h0c-.4-.1-.7-.5-.7-.9v-3.5c0-.4.2-.6.6-.5h0c.4,0,.7.5.7.9v3.5c0,.4-.2.6-.6.5ZM17.6,74.5v-3.5c0-.4-.4-.8-.7-.9h0c-.4-.1-.6.1-.6.5v3.4c0,.4.4.8.7.9h0c.4.1.6-.1.6-.5ZM22.1,69.7l-3.4-1c-.4-.1-.7.1-.7.5h0c0,.4.3.8.7.9l3.4,1c.4.1.7-.1.7-.5h0c0-.4-.3-.8-.7-.9ZM22.2,77.1l-3.4-1.1c-.4-.1-.7,0-.6.5h0c0,.4.3.8.7.9l3.4,1.1c.4.1.7,0,.7-.5h0c0-.4-.3-.8-.7-.9ZM24.8,76.7v-3.6c0-.4-.4-.8-.8-.9h0c-.4-.1-.7.1-.7.5v3.5c0,.4.4.8.8.9h0c.4.1.7,0,.7-.5ZM30.1,70.7v-3.7c0-.4-.4-.8-.8-.9h0c-.4-.1-.7.1-.7.5v3.7c0,.4.4.8.8.9h0c.4.1.7-.1.7-.5ZM30.2,78.4v-3.6c0-.4-.4-.8-.8-.9h0c-.4-.1-.7.1-.7.5v3.6c0,.4.4.8.8.9h0c.4.1.7,0,.7-.5ZM35.3,81.3l-3.8-1.2c-.4-.1-.7,0-.7.5h0c0,.4.3.8.7,1l3.8,1.2c.4.1.8,0,.8-.5h0c0-.4-.3-.8-.8-1ZM44.3,74.7v-3.9c0-.4-.4-.9-.8-1h0c-.5-.1-.8.1-.8.6v3.9c0,.4.4.9.8,1h0c.5.1.8-.1.8-.5ZM44.3,82.8v-3.9c0-.4-.4-.9-.8-1h0c-.5-.1-.8.1-.8.5v3.8c0,.4.4.9.8,1h0c.5.1.8,0,.8-.5ZM50,69.3l-4.3-1.1c-.5-.1-.8.1-.8.6h0c0,.4.4.9.8,1l4.3,1.1c.5.1.9-.1.9-.6h0c0-.4-.4-.9-.9-1ZM50,77.7l-4.3-1.2c-.5-.1-.8.1-.8.5h0c0,.4.4.9.8,1l4.3,1.2c.5.1.9-.1.9-.5h0c0-.4-.4-.9-.9-1ZM50,85.9l-4.3-1.4c-.5-.1-.8,0-.8.5h0c0,.4.4.9.8,1l4.3,1.4c.5.2.9,0,.9-.5h0c0-.4-.4-.9-.9-1.1Z"
		/>
	</svg>
</div>

<Text class="mb-s"
	>{$format('text_blu_trv_pairing_step_info_1', {
		default: '1. Rotate left/right, left/right to open the System menu',
	})}</Text
>

<Text class="mb-s"
	>{$format('text_blu_trv_pairing_step_info_2', {
		default: '2. Turn right, until BLE is shown',
	})}</Text
>

<Text class="mb-s"
	>{capFirstChar(
		$format('or', {
			default: 'OR',
		}),
	)}</Text
>

<Text class="mb-s"
	>{$format('text_blu_trv_pairing_step_info_or_press_back_button', {
		default: 'Press the button on the back of the device.',
	})}</Text
>
